import { flow, types, getEnv } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { SuggestionEntity } from "../../components/suggestion-box/SuggestionBox";

export interface AddressEntity extends SuggestionEntity {
  street: string;
  zip: string;
  city: string;
  state: string;
}

export const AddressCleansingServiceModel = types.model()
  .named("AddressCleansingServiceModel")
  .actions((self) => {
    const findAddressSuggestions = flow(function* (countryCode: string, query: string) {
      const endpoint = endpoints.get("get_address_suggestions");
      endpoint.queryParams = `countryCode=${countryCode}&query=${query}`;

      try {
        return yield getEnv(self).api.get(endpoint);
      } catch {
        return [];
      }
    });

    return {
      search: flow(function* (countryCode: string, query: string): Generator<any, AddressEntity[], any> {
        const response = yield findAddressSuggestions(countryCode, query);
        return response.map((r: any, index: number) => ({
          id: index,
          displayName: r.street ? `${r.zip} ${r.city} - ${r.street}` : `${r.zip} ${r.city}`,
          street: r.street,
          zip: r.zip,
          city: r.city,
          state: r.state
        } as AddressEntity));
      }),
    }
  });
